module.exports = __webpack_public_path__ + "img/mongo_db.785df544.png";